
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12261',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12261",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9672",
  "foundations-components": "static-1.7939",
  "foundations-components-legacy": "static-1.964",
  "foundations-theming": "static-1.4420",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8016",
  "hub-http-shared-msw-handlers": "static-1.9963",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11475",
  "I18n": "static-7.1628",
  "jasmine-runner": "static-1.6468",
  "marketplace-storefront-base": "static-1.12322",
  "quartz": "static-1.7038",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16676",
  "reactive-variable-buffer-atom": "static-1.2861",
  "reporting-testing-lib": "static-1.9484",
  "settings-ui-lib": "static-1.12523",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7141",
  "ui-addon-i18n": "static-1.11153",
  "ui-addon-react-router-dom": "static-1.9545",
  "unified-auth": "static-1.496",
  "unified-auth-core-lib": "static-1.778",
  "usage-tracker": "static-1.7348",
  "usage-tracker-core": "static-1.7198",
  "customer-data-property-utils": "static-1.8093",
  "hub-http": "static-1.6225",
  "integrations-lib": "static-1.16133",
  "marketplace-ui-common": "static-1.19715",
  "property-management-iframe": "static-1.13146",
  "quartz-config": "static-1.816",
  "quartz-core": "static-1.6257",
  "quartz-routing": "static-1.468",
  "quick-fetch": "static-1.3918",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4654",
  "ts-schema": "static-1.4081",
  "ui-universal-auth": "static-1.8982",
  "UIComponents": "static-3.8421",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3401",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3315",
  "quartz-webpack": "static-1.3262",
  "bend-plugin-quartz-routing": "static-1.116",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4208",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4869",
  "foundations-theming-specialty": "static-1.2136",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9428",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5346",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1950",
  "ui-fonts": "static-1.737",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-theming": "static-1.2903",
  "foundations-theming-base": "static-1.3405",
  "stylex": "static-1.33",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3127",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4330",
  "ai-components-ui-library": "static-1.8984",
  "ai-rendering-library": "static-1.10175",
  "chirp-fetch": "static-1.1891",
  "connections-embed-lib": "static-1.996",
  "copilot-toolkit": "static-1.11138",
  "feedback-loader": "static-1.29299",
  "laboratory-lib": "static-3.7160",
  "marketplace-embed": "static-1.22086",
  "marketplace-ui-details": "static-1.9611",
  "marketplace-ui-reviews": "static-1.19671",
  "marketplace-ui-tracking": "static-1.13886",
  "sanitize-text": "static-1.8145",
  "ui-addon-video-player": "static-1.8705",
  "usage-tracker-multi": "static-1.5762",
  "usage-tracker-session-replay": "static-1.5034",
  "wootric-nps": "static-1.6979",
  "quartz-head": "static-1.703",
  "web-vitals": "static-1.5",
  "apollo-link-hub-http": "static-2.4653",
  "immer": "static-1.33",
  "immerable": "static-1.4157",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67551",
  "cssUtils": "static-1.794",
  "flux-actions": "static-1.338",
  "HubStyle": "static-2.11782",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10211",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10369",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7338",
  "icons": "static-2.647",
  "marketplace-ui-apps-core": "static-1.18248",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4519",
  "foundations-components-test-utils": "static-1.5422",
  "quartz-i18n": "static-1.713",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.236",
  "microsoft-drive-integration-lib": "static-1.355",
  "fsm": "static-1.3734",
  "customer-data-objects": "static-1.7672",
  "property-translator": "static-1.5404",
  "hs-locale-management": "static-1.82",
  "frontend-preferences-client": "static-1.7932",
  "hs-promise-utils": "static-1.5596",
  "hubspot-apollo-client": "static-1.4881",
  "integrations-error-boundary-lib": "static-1.13548",
  "integrations-tracking-lib": "static-1.5604",
  "native-integrations-shared-strings": "static-1.7785",
  "reselect": "static-2.16",
  "sanitize": "static-1.4480",
  "superstore": "static-1.4764",
  "ui-shepherd-react": "static-3.10167",
  "ai-settings-ui-library": "static-1.7889",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4653",
  "immutable-less": "static-1.4657",
  "marketplace-ui-client-types": "static-1.17122",
  "nav-meta": "static-1.29679",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10251",
  "ui-addon-upgrades": "static-9.17997",
  "inbound-db-properties-service-client": "static-1.3847",
  "property-management-common": "static-1.5434",
  "ui-addon-iframeable": "static-1.9061",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.713",
  "quartz-test": "static-1.713",
  "quartz-tracking": "static-1.417",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.64",
  "bender-build-tools": "static-1.3205",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21320",
  "ContentUtils": "static-1.68364",
  "customer-data-objects-ui-components": "static-1.13030",
  "sassPrefix": "static-1.156",
  "avatar-components": "static-1.2500",
  "customer-data-filters-ui": "static-1.39776",
  "customer-data-reference-ui-components": "static-1.13166",
  "embedded-academy-lib": "static-1.14344",
  "ExportDialog": "static-6.10392",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41310",
  "reporting-snowflake": "static-1.56169",
  "reporting-ui-components": "static-2.64822",
  "reporting-visualizations": "static-1.59627",
  "ui-addon-teams": "static-1.21557",
  "magpie-lib": "static-1.5555",
  "navigation-components": "static-1.18042",
  "magpie-types": "static-1.5015",
  "simple-logging-lib": "static-1.3052",
  "ai-studio-lib": "static-1.11612",
  "app-governance-lib": "static-1.1538",
  "developer-experience-shared-components": "static-1.10512",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8002",
  "ui-product-approvals": "static-1.28154",
  "ui-tool-access": "static-1.10151",
  "usage-based-billing-components-lib": "static-1.8879",
  "usage-tracker-anonymous": "static-1.5765",
  "usage-tracker-public": "static-1.7159",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3587",
  "persist-promise": "static-1.3700",
  "reference-resolvers": "static-1.8175",
  "ui-extensibility-client-types": "static-1.3929",
  "hubspot-apollo-cache": "static-1.340",
  "universal-page-editor-lib": "static-1.3016",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2778",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5074",
  "purchase-motions-components": "static-1.5908",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1543",
  "crm-component-utils": "static-1.39076",
  "crm-properties-common-lib": "static-1.5887",
  "customer-data-properties": "static-1.51554",
  "framework-data-schema-resolvers": "static-1.6887",
  "property-value-citations": "static-1.2168",
  "reference-resolvers-lite": "static-1.8098",
  "ui-business-units-lib": "static-1.9057",
  "navigation-messaging": "static-1.7369",
  "hubspotter-http-shared-msw-handlers": "static-1.9961",
  "cms-field-types": "static-1.4814",
  "content-icons-ui": "static-1.2229",
  "customer-data-ui-utilities": "static-1.9829",
  "events-data-lib": "static-1.225",
  "conversations-skeleton-state": "static-1.7250",
  "crm-message-bus": "static-1.42986",
  "customer-data-filters-ui-msw-helpers": "static-1.22211",
  "FormUrlGenerator": "static-2.4722",
  "framework-builder-read-service-client": "static-1.4006",
  "framework-data-schema-quick-fetch": "static-1.6792",
  "multi-account-reference-resolvers": "static-1.984",
  "onboarding-tours": "static-1.16607",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13681",
  "academy-common-lib": "static-1.13804",
  "content-assistance-lib": "static-1.7755",
  "dashboard-lib": "static-1.81538",
  "file-manager-components": "static-1.23632",
  "getting-started-shared-tasks": "static-1.18472",
  "hubspot-prosemirror": "static-1.18235",
  "hubspot-prosemirror-plugins": "static-1.18227",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19839",
  "share-with-third-party-component-lib": "static-1.8706",
  "ui-addon-draggable": "static-3.4766",
  "ui-asset-management-lib": "static-1.11036",
  "user-context": "static-1.5106",
  "growth-payments-core": "static-1.25379",
  "reporting-plugins": "static-1.10328",
  "reporting-reports": "static-1.67229",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.726",
  "nest": "static-1.230",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10629",
  "framework-listing-lib": "static-2.28704",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30717",
  "apps-service-types": "static-1.3881",
  "oauth-service-types": "static-1.4252",
  "ui-product-approvals-common": "static-1.49",
  "onboarding-scopes": "static-1.6465",
  "onboarding-tours-client": "static-1.4821",
  "platform-infra-nav-components": "static-1.7670",
  "subscription-experience-data-types": "static-1.14940",
  "crm-record-cards-service-types": "static-1.3598",
  "location-customization-utils-lib": "static-1.9256",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5911",
  "signup-constants": "static-1.18840",
  "signup-ui-url-generator": "static-2.8050",
  "trials-service-types": "static-1.3906",
  "card-properties-lib": "static-1.44192",
  "commerce-subscription-lib": "static-1.37114",
  "crm-actions": "static-1.6329",
  "crm-cards-sdk": "static-1.43586",
  "customer-data-properties-shared-msw-handlers": "static-1.9290",
  "customer-data-tracking": "static-1.6891",
  "hs-resources": "static-1.151",
  "pulse": "static-1.576",
  "calling-global-api": "static-1.64513",
  "calling-internal-common": "static-1.31306",
  "calling-lifecycle-internal": "static-1.65895",
  "calling-lifecycle-messages": "static-1.58189",
  "commerce-products-lib": "static-1.9555",
  "conditional-properties-service-client": "static-1.3798",
  "crm-links": "static-1.6297",
  "external-options-client-types": "static-1.4159",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4224",
  "meetings-icalendar-utils-lib": "static-1.634",
  "multi-currency-client-types": "static-1.3692",
  "object-builder-ui-client": "static-1.48747",
  "pipeline-validation-client-types": "static-1.3966",
  "smart-property-lib": "static-1.7029",
  "tiered-pricing": "static-1.1222",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.10994",
  "crm-pipelines-api-client-types": "static-1.4139",
  "fdsr-migration-layer": "static-1.6",
  "react-dnd-compat": "static-1.4618",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.895",
  "growth-data-modal": "static-1.5431",
  "growth-onboarding-confetti": "static-1.3069",
  "growth-onboarding-next-action-utils": "static-1.1918",
  "onboarding-tours-utils": "static-1.673",
  "ui-shepherd-tracker": "static-1.7548",
  "academy-service-client": "static-1.3684",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39131",
  "FileManagerLib": "static-1.39272",
  "video-embed": "static-1.35759",
  "ui-coaching-tips": "static-1.28556",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11267",
  "video-data-lib": "static-1.34925",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23534",
  "ui-addon-emoji-picker": "static-1.9891",
  "EmailSignatureEditor": "static-1.24373",
  "viral-links-lib": "static-1.7065",
  "data-token-picker": "static-1.16413",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.230",
  "timezone-utils": "static-2.5247",
  "getting-started-shared-tasks-store": "static-1.17590",
  "ui-addon-opt": "static-4.8372",
  "campaign-roi-lib": "static-1.9120",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7329",
  "customer-data-views-management": "static-1.25455",
  "framework-data-table": "static-2.11923",
  "marketing-platform-lib": "static-1.6860",
  "nudge-client-utils": "static-1.2582",
  "nudge-custom-ui-functions": "static-1.1029",
  "app-users-service-client": "static-1.5601",
  "app-users-service-types": "static-1.5009",
  "mini-checkout-client": "static-1.26815",
  "onboarding-utils": "static-1.5355",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28541",
  "edison-service-client-types": "static-1.390",
  "crm_data": "static-4.91966",
  "customer-data-sidebar": "static-2.46014",
  "enrichment-properties-lib": "static-1.16147",
  "commerce-billing-lib": "static-1.19066",
  "commerce-shared-components-lib": "static-1.18538",
  "commerce-tools-ui-lib": "static-1.10373",
  "crm-fe-perf": "static-1.22905",
  "bend-plugin-pulse": "static-1.79",
  "directed-graph": "static-1.938",
  "event-emitter": "static-1.951",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31313",
  "shared-worker-versioning": "static-1.11039",
  "calling-usage-tracker": "static-1.6543",
  "voice-sms-access-library": "static-1.977",
  "commerce-permissions": "static-1.772",
  "products-iframe-lib": "static-1.7932",
  "products-ui-components-shared-msw-handlers": "static-1.10345",
  "data-agent-kit": "static-1.195",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10046",
  "policy-lib": "static-1.6782",
  "react-tinymce": "static-1.55242",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10109",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54368",
  "tinymce-plugins": "static-1.57482",
  "tinymce-themes": "static-1.56338",
  "onboarding-data-sync-lib": "static-1.1960",
  "growth-onboarding-next-action-components": "static-1.1946",
  "user-context-client": "static-1.4616",
  "audio-components": "static-1.5917",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36783",
  "urlinator": "static-1.4540",
  "video-components": "static-1.13270",
  "outpost": "static-1.4185",
  "growth-onboarding-feedback-components": "static-1.6584",
  "content-media-composition-data-lib": "static-1.12281",
  "content-media-compositions": "static-2.16288",
  "media-bridge-lib": "static-1.18931",
  "commerce-tours-lib": "static-1.6101",
  "growth-onboarding-reliability": "static-1.5084",
  "sales-checkout-service-client": "static-1.3643",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21682",
  "sales-email-signature-service-client": "static-1.3846",
  "ts-utils-lib": "static-1.176",
  "breeze-engine-lib": "static-1.647",
  "crm-export-dialog": "static-1.6297",
  "crm-index-associations-lib": "static-1.6444",
  "crm-view-components": "static-1.249",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2339",
  "nudge-renderer-utils": "static-1.2658",
  "whisper-core-api": "static-1.6619",
  "InboxConnectUtils": "static-4.14812",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5546",
  "settings-content-modals": "static-1.46079",
  "crm_universal": "static-1.22013",
  "customer-data-email": "static-1.18040",
  "card-payment-highlight-lib": "static-1.37176",
  "card-subscription-highlight-lib": "static-1.39537",
  "commerce-contract-lib": "static-1.12047",
  "invoices-highlight-card-lib": "static-1.54730",
  "orders-highlight-card-lib": "static-1.21469",
  "products-highlight-card-lib": "static-1.17838",
  "quotes-highlight-card-lib": "static-1.72036",
  "crm-source-interpretation-lib": "static-1.5346",
  "utility-belt": "static-1.2538",
  "payments-enrollment-embed-lib": "static-1.22860",
  "stripe-embedded-components": "static-1.7511",
  "customer-data-rte": "static-1.32995",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5731",
  "payments-post-enroll-local-storage-lib": "static-1.5110",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38126",
  "calling-orchestration-schema": "static-1.35754",
  "sales-views-client-types": "static-1.4262",
  "hub-http-contrib": "static-1.3045",
  "interframe": "static-3.4763",
  "tinymce-data": "static-1.40453",
  "ui-addon-sales-email": "static-1.5214",
  "layout-dnd-components": "static-1.12453",
  "layout-dnd-utils": "static-1.11428",
  "ui-brand-identity-lib": "static-1.15279",
  "NamespacedHubStyle": "static-2.9060",
  "meetings-connect-utils-lib": "static-1.7608",
  "social-insights-client-types": "static-1.22106",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4143",
  "checkout-sdk": "static-3.23658",
  "checkout-service-types": "static-1.3821",
  "company-details-components": "static-1.6200",
  "payment-method-components": "static-1.6911",
  "pricing-pages-ui-components": "static-1.14004",
  "quote-checkout-service-types": "static-1.3471",
  "upgrade-catalog-service-types": "static-1.3522",
  "access-control-lib": "static-1.10438",
  "EmailComponents": "static-1.54743",
  "EmailData": "static-1.53420",
  "redux-less": "static-2.9485",
  "sequences-lib": "static-1.8047",
  "ui-gdpr-components": "static-1.10352",
  "products-ui-components": "static-1.40073",
  "accounting-integrations-ui-components": "static-1.7069",
  "invoices-ui-lib": "static-1.54746",
  "commerce-products-api": "static-1.2299",
  "invoices-iframe-lib": "static-1.56804",
  "quotes-modal-lib": "static-1.102714",
  "quotes-ui-lib": "static-1.80757",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28265",
  "ContentData": "static-1.68439",
  "layout-data-lib": "static-1.9753",
  "hub-http-rxjs": "static-1.802",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3942",
  "billing-payments-client-types": "static-1.3992",
  "react-performance-metrics-lib": "static-1.559",
  "account-and-billing-fintech-outages": "static-3.18594",
  "pricing-pages-api": "static-1.13869",
  "ContentComponents": "static-2.71320",
  "marketing-contacts-lib": "static-1.10040",
  "marketing-email-service-types": "static-1.1917",
  "messaging-editing-lib": "static-1.46274",
  "messaging-usage-based-billing-components-lib": "static-1.1136",
  "automation-ui-source-apps": "static-1.18889",
  "automation-ui-types": "static-1.19807",
  "messaging-types-lib": "static-1.46011",
  "onboarding-settings-client": "static-1.4508",
  "sequences-client-types-lib": "static-1.7904",
  "commerce-tax-lib": "static-1.530",
  "price-books-api": "static-1.722",
  "price-books-components": "static-1.780",
  "property-description-translator": "static-1.3848",
  "ramp-editor": "static-1.156",
  "commerce-analytics-service-client": "static-1.3631",
  "totals-ui-components": "static-1.23596",
  "SalesContentIndexUI": "static-3.9252",
  "advanced-menus-core": "static-1.15131",
  "advanced-menus-lib": "static-1.12071",
  "ui-memberships-settings-lib": "static-1.34045",
  "segments-query-core": "static-1.1422",
  "demographics-service-types": "static-1.1655",
  "eligibility-engine-service-types": "static-1.3187",
  "automation-ui-ubb": "static-1.5723",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7343",
  "data-token-views": "static-1.16394",
  "forms-utils-lib": "static-1.12588",
  "payments-embed-points-lib": "static-1.13039",
  "simple-menus-core": "static-1.15130",
  "simple-menus-lib": "static-1.16647",
  "ui-addon-draggable-compat": "static-2.4259",
  "videoconference-integration-components": "static-1.6821",
  "marketing-contacts-client": "static-1.7520",
  "automation-applications-service-types": "static-1.3510",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77119",
  "short-messages-app-service-client": "static-1.3973",
  "web-interactives-components": "static-1.13767",
  "web-interactives-data": "static-1.13768",
  "messaging-shared-utils-lib": "static-1.585",
  "messaging-user-info-utils-lib": "static-1.755",
  "email-portal-health-service-types": "static-1.980",
  "line-items-api": "static-1.700",
  "commerce-totals-service-types": "static-1.3819",
  "FireAlarmUi": "static-1.4514",
  "sales-templates-service-types-lib": "static-1.4171",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21743",
  "automation-ui-usage-tracking": "static-1.21206",
  "data-studio-ubb": "static-1.2725",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27028",
  "collaboration-sidebar": "static-1.57808",
  "content-management-data-lib": "static-1.5390",
  "copilot-plugins": "static-1.11111",
  "cta-picker": "static-1.36401",
  "customer-agent-discovery-components-lib": "static-1.3084",
  "editor-components": "static-1.13230",
  "editor-iframe-lib": "static-1.8404",
  "error-messaging-js": "static-1.5195",
  "FormsCommonComponents": "static-1.85846",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10649",
  "SharedLegalStrings": "static-1.1751",
  "smart-content-core": "static-1.42441",
  "smart-content-lib": "static-1.43094",
  "social-composer-lib": "static-1.59120",
  "structured-content-lib": "static-1.25190",
  "theme-previewer-lib": "static-1.53255",
  "tinymce-copilot": "static-1.16436",
  "xray-recommendation-lib": "static-1.7909",
  "automation-ui-routing": "static-1.21164",
  "sql-reporting-client-types": "static-1.5643",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42199",
  "campaigns-utils-lib": "static-1.3183",
  "reporting-enablement": "static-1.22925",
  "chatspot-widget-iframe": "static-1.21311",
  "collaboration-sidebar-common": "static-1.2605",
  "forms-ai-lib": "static-1.4322",
  "codemirror-dlb": "static-1.58678",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6434",
  "report-customization-components": "static-1.13176",
  "data-quality-ui-library": "static-1.13038",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.328",
  "reporting-insights-lib": "static-1.1747"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12261",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9672",
  "foundations-components": "/foundations-components/static-1.7939",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.964",
  "foundations-theming": "/foundations-theming/static-1.4420",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8016",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9963",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11475",
  "I18n": "/I18n/static-7.1628",
  "jasmine-runner": "/jasmine-runner/static-1.6468",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12322",
  "quartz": "/quartz/static-1.7038",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16676",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2861",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9484",
  "settings-ui-lib": "/settings-ui-lib/static-1.12523",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7141",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11153",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9545",
  "unified-auth": "/unified-auth/static-1.496",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.778",
  "usage-tracker": "/usage-tracker/static-1.7348",
  "usage-tracker-core": "/usage-tracker-core/static-1.7198",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8093",
  "hub-http": "/hub-http/static-1.6225",
  "integrations-lib": "/integrations-lib/static-1.16133",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19715",
  "property-management-iframe": "/property-management-iframe/static-1.13146",
  "quartz-config": "/quartz-config/static-1.816",
  "quartz-core": "/quartz-core/static-1.6257",
  "quartz-routing": "/quartz-routing/static-1.468",
  "quick-fetch": "/quick-fetch/static-1.3918",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4654",
  "ts-schema": "/ts-schema/static-1.4081",
  "ui-universal-auth": "/ui-universal-auth/static-1.8982",
  "UIComponents": "/UIComponents/static-3.8421",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3401",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3315",
  "quartz-webpack": "/quartz-webpack/static-1.3262",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.116",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4208",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4869",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2136",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9428",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5346",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1950",
  "ui-fonts": "/ui-fonts/static-1.737",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2903",
  "foundations-theming-base": "/foundations-theming-base/static-1.3405",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3127",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4330",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8984",
  "ai-rendering-library": "/ai-rendering-library/static-1.10175",
  "chirp-fetch": "/chirp-fetch/static-1.1891",
  "connections-embed-lib": "/connections-embed-lib/static-1.996",
  "copilot-toolkit": "/copilot-toolkit/static-1.11138",
  "feedback-loader": "/feedback-loader/static-1.29299",
  "laboratory-lib": "/laboratory-lib/static-3.7160",
  "marketplace-embed": "/marketplace-embed/static-1.22086",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9611",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19671",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13886",
  "sanitize-text": "/sanitize-text/static-1.8145",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8705",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5762",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5034",
  "wootric-nps": "/wootric-nps/static-1.6979",
  "quartz-head": "/quartz-head/static-1.703",
  "web-vitals": "/web-vitals/static-1.5",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4653",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4157",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67551",
  "cssUtils": "/cssUtils/static-1.794",
  "flux-actions": "/flux-actions/static-1.338",
  "HubStyle": "/HubStyle/static-2.11782",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10211",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10369",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7338",
  "icons": "/icons/static-2.647",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18248",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4519",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5422",
  "quartz-i18n": "/quartz-i18n/static-1.713",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.236",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.355",
  "fsm": "/fsm/static-1.3734",
  "customer-data-objects": "/customer-data-objects/static-1.7672",
  "property-translator": "/property-translator/static-1.5404",
  "hs-locale-management": "/hs-locale-management/static-1.82",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7932",
  "hs-promise-utils": "/hs-promise-utils/static-1.5596",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4881",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13548",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5604",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7785",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4480",
  "superstore": "/superstore/static-1.4764",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10167",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7889",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4653",
  "immutable-less": "/immutable-less/static-1.4657",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17122",
  "nav-meta": "/nav-meta/static-1.29679",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10251",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17997",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3847",
  "property-management-common": "/property-management-common/static-1.5434",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9061",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.713",
  "quartz-test": "/quartz-test/static-1.713",
  "quartz-tracking": "/quartz-tracking/static-1.417",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.64",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21320",
  "ContentUtils": "/ContentUtils/static-1.68364",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13030",
  "sassPrefix": "/sassPrefix/static-1.156",
  "avatar-components": "/avatar-components/static-1.2500",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39776",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13166",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14344",
  "ExportDialog": "/ExportDialog/static-6.10392",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41310",
  "reporting-snowflake": "/reporting-snowflake/static-1.56169",
  "reporting-ui-components": "/reporting-ui-components/static-2.64822",
  "reporting-visualizations": "/reporting-visualizations/static-1.59627",
  "ui-addon-teams": "/ui-addon-teams/static-1.21557",
  "magpie-lib": "/magpie-lib/static-1.5555",
  "navigation-components": "/navigation-components/static-1.18042",
  "magpie-types": "/magpie-types/static-1.5015",
  "simple-logging-lib": "/simple-logging-lib/static-1.3052",
  "ai-studio-lib": "/ai-studio-lib/static-1.11612",
  "app-governance-lib": "/app-governance-lib/static-1.1538",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10512",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8002",
  "ui-product-approvals": "/ui-product-approvals/static-1.28154",
  "ui-tool-access": "/ui-tool-access/static-1.10151",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8879",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5765",
  "usage-tracker-public": "/usage-tracker-public/static-1.7159",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3587",
  "persist-promise": "/persist-promise/static-1.3700",
  "reference-resolvers": "/reference-resolvers/static-1.8175",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3929",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.340",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3016",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2778",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5074",
  "purchase-motions-components": "/purchase-motions-components/static-1.5908",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1543",
  "crm-component-utils": "/crm-component-utils/static-1.39076",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5887",
  "customer-data-properties": "/customer-data-properties/static-1.51554",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6887",
  "property-value-citations": "/property-value-citations/static-1.2168",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8098",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9057",
  "navigation-messaging": "/navigation-messaging/static-1.7369",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9961",
  "cms-field-types": "/cms-field-types/static-1.4814",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9829",
  "events-data-lib": "/events-data-lib/static-1.225",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7250",
  "crm-message-bus": "/crm-message-bus/static-1.42986",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22211",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4722",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4006",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6792",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.984",
  "onboarding-tours": "/onboarding-tours/static-1.16607",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13681",
  "academy-common-lib": "/academy-common-lib/static-1.13804",
  "content-assistance-lib": "/content-assistance-lib/static-1.7755",
  "dashboard-lib": "/dashboard-lib/static-1.81538",
  "file-manager-components": "/file-manager-components/static-1.23632",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18472",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18235",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18227",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19839",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8706",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4766",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11036",
  "user-context": "/user-context/static-1.5106",
  "growth-payments-core": "/growth-payments-core/static-1.25379",
  "reporting-plugins": "/reporting-plugins/static-1.10328",
  "reporting-reports": "/reporting-reports/static-1.67229",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.726",
  "nest": "/nest/static-1.230",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10629",
  "framework-listing-lib": "/framework-listing-lib/static-2.28704",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30717",
  "apps-service-types": "/apps-service-types/static-1.3881",
  "oauth-service-types": "/oauth-service-types/static-1.4252",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.49",
  "onboarding-scopes": "/onboarding-scopes/static-1.6465",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4821",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7670",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14940",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3598",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9256",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5911",
  "signup-constants": "/signup-constants/static-1.18840",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8050",
  "trials-service-types": "/trials-service-types/static-1.3906",
  "card-properties-lib": "/card-properties-lib/static-1.44192",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37114",
  "crm-actions": "/crm-actions/static-1.6329",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43586",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9290",
  "customer-data-tracking": "/customer-data-tracking/static-1.6891",
  "hs-resources": "/hs-resources/static-1.151",
  "pulse": "/pulse/static-1.576",
  "calling-global-api": "/calling-global-api/static-1.64513",
  "calling-internal-common": "/calling-internal-common/static-1.31306",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65895",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58189",
  "commerce-products-lib": "/commerce-products-lib/static-1.9555",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3798",
  "crm-links": "/crm-links/static-1.6297",
  "external-options-client-types": "/external-options-client-types/static-1.4159",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4224",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.634",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3692",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48747",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3966",
  "smart-property-lib": "/smart-property-lib/static-1.7029",
  "tiered-pricing": "/tiered-pricing/static-1.1222",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10994",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4139",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.6",
  "react-dnd-compat": "/react-dnd-compat/static-1.4618",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.895",
  "growth-data-modal": "/growth-data-modal/static-1.5431",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3069",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1918",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.673",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7548",
  "academy-service-client": "/academy-service-client/static-1.3684",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39131",
  "FileManagerLib": "/FileManagerLib/static-1.39272",
  "video-embed": "/video-embed/static-1.35759",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28556",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11267",
  "video-data-lib": "/video-data-lib/static-1.34925",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23534",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9891",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24373",
  "viral-links-lib": "/viral-links-lib/static-1.7065",
  "data-token-picker": "/data-token-picker/static-1.16413",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.230",
  "timezone-utils": "/timezone-utils/static-2.5247",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17590",
  "ui-addon-opt": "/ui-addon-opt/static-4.8372",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9120",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7329",
  "customer-data-views-management": "/customer-data-views-management/static-1.25455",
  "framework-data-table": "/framework-data-table/static-2.11923",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6860",
  "nudge-client-utils": "/nudge-client-utils/static-1.2582",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1029",
  "app-users-service-client": "/app-users-service-client/static-1.5601",
  "app-users-service-types": "/app-users-service-types/static-1.5009",
  "mini-checkout-client": "/mini-checkout-client/static-1.26815",
  "onboarding-utils": "/onboarding-utils/static-1.5355",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28541",
  "edison-service-client-types": "/edison-service-client-types/static-1.390",
  "crm_data": "/crm_data/static-4.91966",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46014",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16147",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19066",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18538",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10373",
  "crm-fe-perf": "/crm-fe-perf/static-1.22905",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.79",
  "directed-graph": "/directed-graph/static-1.938",
  "event-emitter": "/event-emitter/static-1.951",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31313",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11039",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6543",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.977",
  "commerce-permissions": "/commerce-permissions/static-1.772",
  "products-iframe-lib": "/products-iframe-lib/static-1.7932",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10345",
  "data-agent-kit": "/data-agent-kit/static-1.195",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10046",
  "policy-lib": "/policy-lib/static-1.6782",
  "react-tinymce": "/react-tinymce/static-1.55242",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10109",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54368",
  "tinymce-plugins": "/tinymce-plugins/static-1.57482",
  "tinymce-themes": "/tinymce-themes/static-1.56338",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1960",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1946",
  "user-context-client": "/user-context-client/static-1.4616",
  "audio-components": "/audio-components/static-1.5917",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36783",
  "urlinator": "/urlinator/static-1.4540",
  "video-components": "/video-components/static-1.13270",
  "outpost": "/outpost/static-1.4185",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6584",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12281",
  "content-media-compositions": "/content-media-compositions/static-2.16288",
  "media-bridge-lib": "/media-bridge-lib/static-1.18931",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6101",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5084",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3643",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21682",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3846",
  "ts-utils-lib": "/ts-utils-lib/static-1.176",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.647",
  "crm-export-dialog": "/crm-export-dialog/static-1.6297",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6444",
  "crm-view-components": "/crm-view-components/static-1.249",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2339",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2658",
  "whisper-core-api": "/whisper-core-api/static-1.6619",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14812",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5546",
  "settings-content-modals": "/settings-content-modals/static-1.46079",
  "crm_universal": "/crm_universal/static-1.22013",
  "customer-data-email": "/customer-data-email/static-1.18040",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37176",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39537",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12047",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54730",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21469",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17838",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72036",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5346",
  "utility-belt": "/utility-belt/static-1.2538",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22860",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7511",
  "customer-data-rte": "/customer-data-rte/static-1.32995",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5731",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5110",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38126",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35754",
  "sales-views-client-types": "/sales-views-client-types/static-1.4262",
  "hub-http-contrib": "/hub-http-contrib/static-1.3045",
  "interframe": "/interframe/static-3.4763",
  "tinymce-data": "/tinymce-data/static-1.40453",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5214",
  "layout-dnd-components": "/layout-dnd-components/static-1.12453",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11428",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15279",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9060",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7608",
  "social-insights-client-types": "/social-insights-client-types/static-1.22106",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4143",
  "checkout-sdk": "/checkout-sdk/static-3.23658",
  "checkout-service-types": "/checkout-service-types/static-1.3821",
  "company-details-components": "/company-details-components/static-1.6200",
  "payment-method-components": "/payment-method-components/static-1.6911",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14004",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3471",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3522",
  "access-control-lib": "/access-control-lib/static-1.10438",
  "EmailComponents": "/EmailComponents/static-1.54743",
  "EmailData": "/EmailData/static-1.53420",
  "redux-less": "/redux-less/static-2.9485",
  "sequences-lib": "/sequences-lib/static-1.8047",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10352",
  "products-ui-components": "/products-ui-components/static-1.40073",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7069",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54746",
  "commerce-products-api": "/commerce-products-api/static-1.2299",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56804",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102714",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80757",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28265",
  "ContentData": "/ContentData/static-1.68439",
  "layout-data-lib": "/layout-data-lib/static-1.9753",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.802",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3942",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3992",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.559",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18594",
  "pricing-pages-api": "/pricing-pages-api/static-1.13869",
  "ContentComponents": "/ContentComponents/static-2.71320",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10040",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1917",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46274",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1136",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18889",
  "automation-ui-types": "/automation-ui-types/static-1.19807",
  "messaging-types-lib": "/messaging-types-lib/static-1.46011",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4508",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7904",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.530",
  "price-books-api": "/price-books-api/static-1.722",
  "price-books-components": "/price-books-components/static-1.780",
  "property-description-translator": "/property-description-translator/static-1.3848",
  "ramp-editor": "/ramp-editor/static-1.156",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3631",
  "totals-ui-components": "/totals-ui-components/static-1.23596",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9252",
  "advanced-menus-core": "/advanced-menus-core/static-1.15131",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12071",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34045",
  "segments-query-core": "/segments-query-core/static-1.1422",
  "demographics-service-types": "/demographics-service-types/static-1.1655",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3187",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5723",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7343",
  "data-token-views": "/data-token-views/static-1.16394",
  "forms-utils-lib": "/forms-utils-lib/static-1.12588",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13039",
  "simple-menus-core": "/simple-menus-core/static-1.15130",
  "simple-menus-lib": "/simple-menus-lib/static-1.16647",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4259",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6821",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7520",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3510",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77119",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3973",
  "web-interactives-components": "/web-interactives-components/static-1.13767",
  "web-interactives-data": "/web-interactives-data/static-1.13768",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.585",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.755",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.980",
  "line-items-api": "/line-items-api/static-1.700",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3819",
  "FireAlarmUi": "/FireAlarmUi/static-1.4514",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4171",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21743",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21206",
  "data-studio-ubb": "/data-studio-ubb/static-1.2725",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27028",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57808",
  "content-management-data-lib": "/content-management-data-lib/static-1.5390",
  "copilot-plugins": "/copilot-plugins/static-1.11111",
  "cta-picker": "/cta-picker/static-1.36401",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3084",
  "editor-components": "/editor-components/static-1.13230",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8404",
  "error-messaging-js": "/error-messaging-js/static-1.5195",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85846",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10649",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1751",
  "smart-content-core": "/smart-content-core/static-1.42441",
  "smart-content-lib": "/smart-content-lib/static-1.43094",
  "social-composer-lib": "/social-composer-lib/static-1.59120",
  "structured-content-lib": "/structured-content-lib/static-1.25190",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53255",
  "tinymce-copilot": "/tinymce-copilot/static-1.16436",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7909",
  "automation-ui-routing": "/automation-ui-routing/static-1.21164",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5643",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42199",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3183",
  "reporting-enablement": "/reporting-enablement/static-1.22925",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21311",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2605",
  "forms-ai-lib": "/forms-ai-lib/static-1.4322",
  "codemirror-dlb": "/codemirror-dlb/static-1.58678",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6434",
  "report-customization-components": "/report-customization-components/static-1.13176",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13038",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.328",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1747"
}
};
